/*
 * The one-time-code field (design Req 9; web.dev SMS OTP, GOV.UK confirm a
 * phone number). ONE real input — numeric keyboard, `one-time-code` autofill,
 * screen-reader friendly — with six slots drawn over it. Spaces and dashes are
 * accepted and dropped; the sixth digit submits.
 */
import React, { useEffect, useRef, useState } from "react";

export const normalizeCode = (raw) => (raw || "").replace(/\D/g, "").slice(0, 6);

const CodeField = ({
  id,
  label,
  value,
  onChange,
  onComplete,
  invalid,
  disabled,
  describedBy,
  autoFocus,
}) => {
  const ref = useRef(null);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (autoFocus && ref.current) ref.current.focus();
  }, [autoFocus]);

  const handle = (e) => {
    const next = normalizeCode(e.target.value);
    onChange(next);
    if (next.length === 6 && next !== value && onComplete) onComplete(next);
  };

  const active = Math.min(value.length, 5);
  const cls = `code${invalid ? " err" : ""}${disabled ? " dis" : ""}${focused ? " focus" : ""}`;
  const slots = [];
  for (let i = 0; i < 6; i += 1) {
    if (i === 3) slots.push(<span key="gap" className="gap" aria-hidden="true" />);
    slots.push(
      <span key={i} className={`slot${focused && i === active ? " on" : ""}`} aria-hidden="true">
        {value[i] || ""}
      </span>
    );
  }

  return (
    <div className="fld">
      <label className="lbl" htmlFor={id}>
        {label}
      </label>
      <div className={cls}>
        <input
          ref={ref}
          id={id}
          name="code"
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9 \-]*"
          maxLength={11}
          value={value}
          onChange={handle}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          disabled={disabled}
          aria-invalid={invalid || undefined}
          aria-describedby={describedBy}
        />
        {slots}
      </div>
    </div>
  );
};

export default CodeField;
